exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-0e907a50]{margin-top:12px}", ""]);

// exports
